function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
/* eslint no-unused-vars: "off" */
import MockGridModel from "./MockGridModel.js";
import memoizeClear from "./memoizeClear.js";
/**
 * A class to mock a tree model so can test out tree models.
 * Whenever a row is expanded, it creates a child model for that row, which can then make a child for those rows, etc.
 */
class MockTreeGridModel extends MockGridModel {
  constructor() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$rowCount = _ref.rowCount,
      rowCount = _ref$rowCount === void 0 ? MockTreeGridModel.DEFAULT_ROW_COUNT : _ref$rowCount,
      _ref$columnCount = _ref.columnCount,
      columnCount = _ref$columnCount === void 0 ? MockTreeGridModel.DEFAULT_COLUMN_COUNT : _ref$columnCount,
      _ref$children = _ref.children,
      _children = _ref$children === void 0 ? new Map() : _ref$children,
      _ref$childRowCount = _ref.childRowCount,
      _childRowCount = _ref$childRowCount === void 0 ? Math.ceil(Math.max(MockTreeGridModel.MIN_CHILD_ROW_COUNT, rowCount * MockTreeGridModel.DEFAULT_CHILD_ROW_COUNT_FACTOR)) : _ref$childRowCount,
      _ref$maxDepth = _ref.maxDepth,
      _maxDepth = _ref$maxDepth === void 0 ? MockTreeGridModel.MAX_DEPTH : _ref$maxDepth;
    super({
      rowCount,
      columnCount
    });
    _defineProperty(this, "children", void 0);
    _defineProperty(this, "childRowCount", void 0);
    _defineProperty(this, "maxDepth", void 0);
    /**
     * Returns the map key and the offsetRow given the provided children and row index.
     * If the returned key is null, then this offset row is within this model.
     * Only returning the key instead of the model so that memoize doesn't cache a bunch of the children models after they've been deleted (collapsed).
     */
    _defineProperty(this, "getCachedModelRowOffset", memoizeClear((children, row) => {
      var key = null;
      var offsetRow = row;
      // Need to iterate through the map in order... sort it first
      var sortedEntries = [...children].sort((a, b) => a[0] - b[0]);
      for (var i = 0; i < sortedEntries.length; i += 1) {
        var _sortedEntries$i = _slicedToArray(sortedEntries[i], 2),
          childRow = _sortedEntries$i[0],
          childModel = _sortedEntries$i[1];
        if (offsetRow <= childRow) {
          break;
        }
        var childRowCount = childModel.rowCount;
        if (offsetRow <= childRow + childRowCount) {
          key = childRow;
          offsetRow = offsetRow - childRow - 1;
          break;
        }
        offsetRow -= childRowCount;
      }
      return {
        key,
        offsetRow
      };
    }, {
      max: 10000
    }));
    _defineProperty(this, "getCachedTextForRowHeader", memoizeClear((children, row) => {
      var _this$getCachedModelR = this.getCachedModelRowOffset(children, row),
        key = _this$getCachedModelR.key,
        offsetRow = _this$getCachedModelR.offsetRow;
      if (key != null) {
        var model = children.get(key);
        if (model !== undefined) {
          return "".concat(key, ".").concat(model.textForRowHeader(offsetRow));
        }
      }
      return "".concat(offsetRow);
    }, {
      max: 10000
    }));
    _defineProperty(this, "getCachedTextForCell", memoizeClear((children, column, row) => {
      var _this$getCachedModelR2 = this.getCachedModelRowOffset(children, row),
        key = _this$getCachedModelR2.key,
        offsetRow = _this$getCachedModelR2.offsetRow;
      if (key != null) {
        var model = children.get(key);
        if (model !== undefined) {
          return "".concat(key, ".").concat(model.textForCell(column, offsetRow));
        }
      }
      return "".concat(column, ",").concat(offsetRow);
    }, {
      max: 10000
    }));
    _defineProperty(this, "getCachedIsRowExpandable", memoizeClear((children, row, maxDepth) => {
      var depth = this.getCachedDepthForRow(children, row);
      return depth < maxDepth;
    }, {
      max: 10000
    }));
    _defineProperty(this, "getCachedIsRowExpanded", memoizeClear((children, row) => {
      var _this$getCachedModelR3 = this.getCachedModelRowOffset(children, row),
        key = _this$getCachedModelR3.key,
        offsetRow = _this$getCachedModelR3.offsetRow;
      if (key != null) {
        var model = children.get(key);
        if (model !== undefined) {
          return model.isRowExpanded(offsetRow);
        }
      }
      return children.has(offsetRow);
    }, {
      max: 10000
    }));
    _defineProperty(this, "getCachedDepthForRow", memoizeClear((children, row) => {
      var _this$getCachedModelR4 = this.getCachedModelRowOffset(children, row),
        key = _this$getCachedModelR4.key,
        offsetRow = _this$getCachedModelR4.offsetRow;
      if (key != null) {
        var model = children.get(key);
        if (model !== undefined) {
          return model.depthForRow(offsetRow) + 1;
        }
      }
      return 0;
    }, {
      max: 10000
    }));
    this.children = _children;
    this.childRowCount = _childRowCount;
    this.maxDepth = _maxDepth;
  }
  textForCell(column, row) {
    return this.getCachedTextForCell(this.children, column, row);
  }
  textForRowHeader(row) {
    return this.getCachedTextForRowHeader(this.children, row);
  }
  isRowMovable(row) {
    return false;
  }
  get hasExpandableRows() {
    return true;
  }
  get isExpandAllAvailable() {
    return false;
  }
  get floatingBottomRowCount() {
    return 0;
  }
  isRowExpandable(row) {
    return this.getCachedIsRowExpandable(this.children, row, this.maxDepth);
  }
  isRowExpanded(row) {
    return this.getCachedIsRowExpanded(this.children, row);
  }
  setRowExpanded(row, isExpanded) {
    var expandDescendants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _this$getCachedModelR5 = this.getCachedModelRowOffset(this.children, row),
      key = _this$getCachedModelR5.key,
      offsetRow = _this$getCachedModelR5.offsetRow;

    // We always set a new map so that our memoize functions work properly
    var children = new Map(this.children);
    if (key != null) {
      var model = this.children.get(key);
      if (model !== undefined) {
        var originalChildRowCount = model.rowCount;
        model.setRowExpanded(offsetRow, isExpanded, expandDescendants);
        this.numRows += model.rowCount - originalChildRowCount;
      }
    } else if (!isExpanded) {
      var childModel = children.get(offsetRow);
      if (childModel !== undefined) {
        this.numRows -= childModel.rowCount;
        children.delete(offsetRow);
      }
    } else {
      var child = new MockTreeGridModel({
        rowCount: this.childRowCount,
        columnCount: this.numColumns
      });
      children.set(offsetRow, child);
      this.numRows += child.rowCount;
    }
    this.children = children;
  }
  expandAll() {
    throw new Error('Expand all not implemented.');
  }
  collapseAll() {
    throw new Error('Collapse all not implemented.');
  }
  depthForRow(row) {
    return this.getCachedDepthForRow(this.children, row);
  }
}
_defineProperty(MockTreeGridModel, "DEFAULT_ROW_COUNT", 1000000000);
_defineProperty(MockTreeGridModel, "DEFAULT_COLUMN_COUNT", 100);
/** How many rows a child tree should have related to the parent. Eg. if parent has 10000 rows, child will have 100 */
_defineProperty(MockTreeGridModel, "DEFAULT_CHILD_ROW_COUNT_FACTOR", 0.01);
_defineProperty(MockTreeGridModel, "MIN_CHILD_ROW_COUNT", 10);
_defineProperty(MockTreeGridModel, "MAX_DEPTH", 10);
export default MockTreeGridModel;
//# sourceMappingURL=MockTreeGridModel.js.map